import {
    GET_SUPERADMIN_REPORT_REQUEST,
    GET_SUPERADMIN_REPORT_SUCCESS,
    GET_SUPERADMIN_REPORT_FAILED
} from '../../actions/superadmin/get-superadmin-reports'

const initialState = {
    allReports: [],
    requesting: false,
    error: null
}

export const superAdminReports = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPERADMIN_REPORT_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                allReports: [],
                error: null
            })
        case GET_SUPERADMIN_REPORT_SUCCESS:
            return Object.assign({}, state, {
                allReports: Object.values(action.payload.data.payload.orderedMessages),
                requesting: false,
                error: action.error,
            })
        case GET_SUPERADMIN_REPORT_FAILED:
            return Object.assign({}, state, {
                allReports: [],
                requesting: false,
                error: null
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/superadmin/reports.js